<template>
	<div class="bg-white border-gray-200 flex flex-col overflow-hidden rounded-lg border shadow-sm">
		<div class="bg-gray-50 border-gray-200 flex items-center border-b py-3 pe-5 ps-3">
			<Icon
				:name="data?.user_type === 'developer' ? 'mdi:code-tags' : 'mdi:account'"
				:class="[
					'text-gray-50 me-3 h-12  w-12 rounded-full p-2.5',
					data?.user_type === 'developer' ? 'bg-yellow-500' : 'bg-gray-400'
				]"
			/>
			<div class="flex flex-col">
				<span class="text-neutral-800 text-base">
					{{ (data?.user_firstname || "~") + " " + (data?.user_lastname || "~") }}
				</span>
				<span
					:class="['mt-1 text-xs', data?.user_type === 'developer' ? 'text-yellow-500' : 'text-neutral-700']"
				>
					{{ type.name }}
				</span>
			</div>
			<div class="flex-grow" />
			<span
				v-if="currentUser?.id === data?.user_id"
				class="text-neutral-700 bg-red-500 flex cursor-pointer items-center rounded-full bg-opacity-0 duration-300 hover:text-red-500 hover:bg-opacity-10"
				@click="emit('delete')"
			>
				<Icon name="mdi:delete" class="h-8 w-8 p-1" />
			</span>
		</div>
		<div class="text-neutral-800 whitespace-pre-wrap p-5">
			{{ data?.message || "~" }}
		</div>
		<div v-if="data?.image_id || data?.video_id" class="border-gray-200 mx-5 border-t" />
		<div v-if="data?.image_id || data?.video_id" class="flex items-center gap-5 px-5 py-5">
			<NuxtLink
				v-if="data?.image_id"
				class="ripple-bg-white text-gray-600 border-gray-400 flex cursor-pointer items-center rounded-md border px-3 py-2"
				target="_blank"
				:to="runtimeConfig.public.baseUrl + data?.image_path"
			>
				<Icon name="mdi:image" class="me-3 h-5 w-5" />
				<span class="text-sm">{{ $t("image") }}</span>
			</NuxtLink>
			<NuxtLink
				v-if="data?.video_id"
				class="ripple-bg-white text-gray-600 border-gray-400 flex cursor-pointer items-center rounded-md border px-3 py-2"
				target="_blank"
				:to="runtimeConfig.public.baseUrl + data?.video_path"
			>
				<Icon name="mdi:video" class="me-3 h-5 w-5" />
				<span class="text-sm">{{ $t("video") }}</span>
			</NuxtLink>
		</div>
		<div
			:class="[
				'pointer-events-none -mt-6 h-6 opacity-10',
				data?.user_type === 'developer'
					? 'bg-gradient-to-t from-yellow-500 to-white'
					: 'bg-gradient-to-t from-gray-400 to-white'
			]"
		/>
	</div>
</template>

<script setup lang="ts">
import type { DevTicketMessage } from "~/models/dev-ticket"

const runtimeConfig = useRuntimeConfig()
const userStore = useUserStore()
const { $i18n } = useNuxtApp()

const props = defineProps<{
	data: DevTicketMessage | null
}>()

const currentUser = computed(() => userStore.user)

const types = computed(() => userStore.types)

const type = computed(
	() =>
		types.value.find((v) => v.value === props.data?.user_type) || {
			name: $i18n.t("admin"),
			value: "admin"
		}
)

const emit = defineEmits<{
	delete: []
}>()
</script>
